module.exports = __webpack_public_path__ + "static/media/appraisal.0fe65c25.jpg";